import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '../../';

const DropdownIndicator = ({ selectProps }) => (
  <div data-desc={`select__${selectProps.input.name}_open`}>
    <Icon name='chevron-down' alt='open dropdown' />
  </div>
);

DropdownIndicator.propTypes = {
  selectProps: PropTypes.any.isRequired
};

export default DropdownIndicator;
